// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__N9rCu","requiredAsterisk":"Info_requiredAsterisk__1fUKb"};